<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";
import { CheckCircleIcon, InformationCircleIcon} from "@heroicons/vue/20/solid/index.js";

defineOptions({ layout: GuestLayout });
</script>

<template>
    <div class="bg-white px-6 py-32 lg:px-8">
        <div class="mx-auto max-w-3xl text-base/7 text-gray-700">
            <p class="text-base/7 font-semibold text-red-700">Introducing</p>
            <h1 class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Instrument Repair</h1>
            <p class="mt-6 text-xl/8">The Band Instrument Repair Academy provides top-quality repair services for woodwind and brass instruments at competitive prices, catering specifically to the local music community.</p>
            <div class="mt-8 max-w-2xl">
                <p class="mt-6">With a focus on delivering quick turnaround times, their skilled technicians ensure that instruments are back in playing condition efficiently, minimizing downtime for musicians and schools.</p>
            </div>
            <figure class="mt-16 sm:pl-4">
                <img class="aspect-auto sm:w-4/5 rounded-xl bg-gray-50 object-cover" src="../../../public/images/workbenchCrop@0.5x.jpg" alt="" />
<!--                <figcaption class="mt-4 flex gap-x-2 text-sm/6 text-gray-500">-->
<!--                    <InformationCircleIcon class="mt-0.5 size-5 flex-none text-gray-300" aria-hidden="true" />-->
<!--                    Main workbench for teaching.-->
<!--                </figcaption>-->
            </figure>
            <div class="mt-16 max-w-2xl">
                <p class="mt-6">Whether it's routine maintenance or more complex repairs, the academy combines affordability with expertise to meet the needs of musicians and educators alike.</p>
                <p class="mt-6">Call or stop by our storefront for repairs.</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
